import Freshmart from "../../assets/Projects/Freshmart/freshmart.png";

import DanEnergy from "../../assets/Projects/DanEnergy/danenergy.png";

import Equb from "../../assets/Projects/Equb/equb.png";

import Uber1 from "../../assets/Projects/Uber/Uber1.svg";
import Uber2 from "../../assets/Projects/Uber/Uber2.svg";
import Uber3 from "../../assets/Projects/Uber/Uber3.svg";

import Netflix1 from "../../assets/Projects/Netflix/Signup.png";
import Netflix2 from "../../assets/Projects/Netflix/Login.png";
import Netflix3 from "../../assets/Projects/Netflix/Profiles.png";
import Netflix4 from "../../assets/Projects/Netflix/Hero.png";
import Netflix5 from "../../assets/Projects/Netflix/Cards.png";
import Netflix6 from "../../assets/Projects/Netflix/cardshover.png";
import Netflix7 from "../../assets/Projects/Netflix/cardsdetails.png";
import Netflix8 from "../../assets/Projects/Netflix/videoplayer.png";

import Summer from "../../assets/Projects/MyGebeya/summer.png";
import Winter from "../../assets/Projects/MyGebeya/winter.png";
import Products from "../../assets/Projects/MyGebeya/products.png";
import Products2 from "../../assets/Projects/MyGebeya/products2.png";
import Footer from "../../assets/Projects/MyGebeya/footer.png";
import Item from "../../assets/Projects/MyGebeya/item.png";
import Checkout from "../../assets/Projects/MyGebeya/checkout.png";
import Billing from "../../assets/Projects/MyGebeya/billing.png";
import Placeholder from "../../assets/Projects/MyGebeya/place.png";

import Hero from "../../assets/Projects/contact.ai/hero.png";
import Pricing from "../../assets/Projects/contact.ai/pricing.png";
import About from "../../assets/Projects/contact.ai/about.png";
import Services from "../../assets/Projects/contact.ai/services.png";

import EcallsHero from "../../assets/Projects/ecalls/ecallshero.png";
import EcallsAbout from "../../assets/Projects/ecalls/ecallsabout.png";
import EcallsPlans from "../../assets/Projects/ecalls/ecallsplans.png";
import EcallContact from "../../assets/Projects/ecalls/ecallscontact.png";

import HillHero from "../../assets/Projects/hillstech/hillhero.png";
import HillContact from "../../assets/Projects/hillstech/hillcon.png";
import HillProjects from "../../assets/Projects/hillstech/hillpro.png";
import HillServices from "../../assets/Projects/hillstech/hillser.png";
import Hillservices2 from "../../assets/Projects/hillstech/hillser2.png";

export const projectsData = [
  {
    id: 8,
    image: Hero,
    images: [Hero, Pricing, About, Services],
    title: "Contact.ai",
    category: "web",
    description:
      "Contacti AI provides AI-powered omni-channel communication and appointment management solutions, seamlessly integrating with CRMs to enhance operational efficiency and customer satisfaction.",
    role: "Frontend Developer",
    tools: "TypeScript, NextJs, Tailwind CSS",
    github: "https://www.contacti.ai/",
  },
  {
    id: 7,
    image: EcallsHero,
    images: [EcallsHero, EcallsAbout, EcallsPlans, EcallContact],
    title: "Exclusive Calls",
    category: "web",
    description:
      "Exclusive Calls provides clients with full access to the actual phone system in order to see every outgoing and incoming call activity from their employees at their own discretion. ",
    role: "Frontend Developer",
    tools: "JavaScript, HTML, CSS",
    github: "https://www.exclusivecalls.com/",
  },
  {
    id: 6,
    image: HillHero,
    images: [HillHero, HillContact, HillProjects, HillServices, Hillservices2],
    title: "Hills Tech",
    category: "web",
    description:
      "Hilltech seamlessly intertwines concepts, individuals, and the potential of novel and advancing technologies to enable contemporary businesses to flourish in the digital realm.",
    role: "Frontend Developer",
    tools: "JavaScript, React, Tailwind CSS",
    github: "https://www.hillstech.de",
  },
  {
    id: 5,
    image: Summer,
    images: [
      Summer,
      Winter,
      Products,
      Products2,
      Footer,
      Item,
      Checkout,
      Billing,
      Placeholder,
    ],
    title: "MyGebeya",
    category: "web",
    description:
      "MyGebeya is a user-friendly online clothing store offering a personalized shopping experience with handpicked items for different styles.",
    role: "Full Stack Developer",
    tools: "React, JavaScript, Material UI, Redux Toolkit, Strapi",
    github: "https://github.com/ateyob/MyGebeya",
  },

  {
    id: 4,
    image: Netflix4,
    images: [
      Netflix1,
      Netflix2,
      Netflix3,
      Netflix4,
      Netflix5,
      Netflix6,
      Netflix7,
      Netflix8,
    ],
    title: "Netflix Clone",
    category: "web",
    link: "https:/mymovie-ateyob.vercel.app",
    description:
      "This Netflix-clone website offers users the ability to create an account using their email, Google, or GitHub credentials, and provides a wide range of movies to browse. Users have the option to select and add movies to their personal favorites list, and can stream their preferred movies at their convenience.",
    role: "Front-end Developer",
    tools: "NextJs, TypeScript, Tailwind CSS, MongoDB, Git",
    url: "https:/mymovie-ateyob.vercel.app",
    github: "https://github.com/ateyob/netflix-clone",
  },

  // {
  //   id: 1,
  //   image: DanEnergy,
  //   images: [DanEnergy],
  //   title: "Dan Energy's Website",
  //   category: "web",
  //   link: "http://danenergyethiopia.com/",
  //   description: "",
  //   // "DAN Energy is a company that provides a range of technology and business services, including R&D, information technologies, business process outsourcing, training and placement, and venture capital support for entrepreneurs in Africa with a focus on youth, mothers, and sisters, and serves clients, NGOs, and governments.",
  //   role: "Lead Front-end Developer",
  //   tools: "React, JavaScript, Chakra UI, Git",
  //   url: "http://danenergyethiopia.com",
  //   github: " Private ",
  // },

  {
    id: 3,
    image: Uber1,
    images: [Uber1, Uber2, Uber3],
    title: "Uber Clone",
    category: "app",
    description:
      "Uber clone is an app that integrates with Google Maps and includes in-app booking, distance calculations, and car selection.",
    role: "Lead Front-end Developer",
    tools: "React Native, JavaScript, Tailwind CSS, Git",
    github: "https://github.com/ateyob/uber-clone",
  },

  // {
  //   id: 2,
  //   image: Freshmart,
  //   images: [Freshmart],
  //   title: "Freshmart",
  //   category: "web",
  //   description:
  //     "Freshmart is a modern supermarket offering fresh groceries and household items at competitive prices with a convenient online shopping experience, including an Admin panel to track products and orders.",
  //   role: "Front-end Developer",
  //   tools: "React, JavaScript, Material UI, Gitblit ",
  //   github: "Private",
  // },

  // {
  //   id: 5,
  //   image: Equb,
  //   images: [Equb],
  //   title: "Equb Admin panel",
  //   category: "web",
  //   description: "",
  //   // "eQub is a financial service that modernizes the traditional Ethiopian practice of eQub, where a group of people contribute a certain amount every month and take turns receiving the collected funds. eQub provides a platform for these groups to easily organize and manage their contributions, making the process more convenient and efficient. Through the use of the web app, eQub allows people to continue participating in this traditional financial practice in a more modern and streamlined way. I was involved in making the admin panel.",
  //   role: "Front-end Developer",
  //   tools: "React, JavaScript, Chakra UI, Gitblit",
  //   github: "Private",
  // },
];

export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "web",
  },
  {
    name: "app",
  },

  {
    name: "design",
  },
];
